export enum SidePanelClientSettingsTab {
  general = 'general',
  connect = 'connect',
  bandwidth = 'bandwidth',
  proxy = 'proxy',
  retention = 'retention',
  logging = 'logging',
  repository = 'repository',
  advanced = 'advanced',
  memory = 'memory'
}
